import React, { Component } from "react";
import { Modal, Form, Col } from "react-bootstrap";
import { graphql, withApollo } from "react-apollo";
import * as compose from "lodash.flowright";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import { ExcelRenderer } from 'react-excel-renderer';
import {
    getAuthorizedBranchIds,
    getAuthorizedClassIds,
    getAuthorizedSectionIds,
    filterByAuthorizedIds
} from "../../utils/authHelper";
import TableSearchwithStudentResult from "../questioners/manage_questin_papers/TableSearchwithStudentResult";
import SampleExcel from '../../../images/Studentssample.xls';
import './_educationManagementStudents.scss';

const ADD_STUDENT = gql`
  mutation($params: EduStudentInput) {
    AddEducationalStudents(params: $params)
  }
`;

const GET_CLASSES = gql`
    query($id: Int) {
        getExamClasses(id: $id) {
            id
            class
        }
    }
`;

const GET_STREAMS = gql`
    query {
        getStreams {
            id
            stream
            classes
        }
    }
`;

// Classes that require a stream selection — Class 11 (id 1) and Class 12 (id 2),
// i.e. Intermediate 1st/2nd year.
const STREAM_CLASS_IDS = [1, 2];
const isStreamClass = (classId) => STREAM_CLASS_IDS.includes(parseInt(classId));

const GET_BRANCHES = gql`
    query getBranches($institution_id: Int!) {
        getBranches(institution_id: $institution_id) {
            id
            branch_name
            sections {
                id
                class_id
                stream_id
                section_name
            }
        }
    }
`;

const EMPTY_STATE = {
    branch: "",
    class: "",
    stream: "",
    section: "",
    branchError: "",
    classError: "",
    streamError: "",
    sectionError: "",
    fileError: "",
    submitError: "",
    successMessage: "",
    StudentsFilterData: [],
    getClasses: [],
    getStreams: [],
    getSections: [],
    isSubmitting: false,
    loadingSpinner: 0,
    currentStep: 1,

    // Add mode: 'single' (one-student form) | 'bulk' (Excel upload)
    activeTab: "single",
    s_admission_no: "",
    s_roll_no: "",
    s_name: "",
    s_mobile: "",
    s_password: "",
    s_father_name: "",
    s_father_phone: "",
    s_mother_name: "",
    s_mother_phone: "",
    s_parent_password: "",
    s_profile_base64: "",
    s_profile_name: "",
    singleError: "",
};

class StudentModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...EMPTY_STATE,
            dataClear: 0,
            branches: [],
            allClasses: [],
            allStreams: [],
        };
    }

    componentDidMount() {
        this.loadBranches();
        this.loadClasses();
        this.loadStreams();
    }

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear === 0) {
            this.isSubmittingFlag = false;
            this.setState({ ...EMPTY_STATE, dataClear: 1 });
        }
        if (this.props.show === false && this.state.dataClear === 1) {
            this.setState({ dataClear: 0 });
        }
    }

    loadBranches = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_BRANCHES,
                variables: { institution_id: parseInt(Cookies.get("institutionid")) },
                fetchPolicy: "network-only",
            });
            let branches = result.data.getBranches || [];
            // Show only the branches the user is authorized for. The branch_id cookie is a
            // comma-separated list (e.g. "10,12,15"), so match against every id.
            const authorizedIds = getAuthorizedBranchIds();
            if (authorizedIds.length) {
                branches = branches.filter(b => authorizedIds.includes(String(b.id)));
            }
            const allowedClasses = getAuthorizedClassIds();
            const allowedSections = getAuthorizedSectionIds();
            if (allowedClasses.length || allowedSections.length) {
                branches = branches.map(b => ({
                    ...b,
                    sections: filterByAuthorizedIds(
                        filterByAuthorizedIds(b.sections || [], allowedSections, "id"),
                        allowedClasses,
                        "class_id"
                    )
                }));
            }
            this.setState({ branches });
        } catch (_) { }
    };

    loadClasses = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_CLASSES,
                variables: { id: 1 },
                fetchPolicy: "network-only",
            });
            const classes = filterByAuthorizedIds(
                result.data.getExamClasses || [],
                getAuthorizedClassIds(),
                "id"
            );
            this.setState({ allClasses: classes });
        } catch (_) { }
    };

    loadStreams = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_STREAMS,
                fetchPolicy: "network-only",
            });
            this.setState({ allStreams: result.data.getStreams || [] });
        } catch (_) { }
    };

    handleFileChange = e => {
        this.setState({ StudentsFilterData: [], fileError: "" });
        const target = e.target;
        const fileObj = target.files[0];
        if (!fileObj) return;

        const allowedTypes = [
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ];
        if (!allowedTypes.includes(fileObj.type)) {
            this.setState({ fileError: "Invalid format. Please upload an .xls file." });
            target.value = "";
            return;
        }

        ExcelRenderer(fileObj, (err, resp) => {
            target.value = "";
            if (err) return;
            const studentData = [];
            if (resp.rows) {
                resp.rows.slice(1).forEach(item => {
                    if (item[1] != null && item[2] != null && item[3] != null) {
                        let fatherName = item[5] ? item[5].toString() : "";
                        let fatherMobile = item[6] ? item[6].toString() : "";
                        let studentMobile = item[4] != null ? item[4].toString() : "";
                        studentData.push({
                            admission_no: item[1].toString(),
                            student_roll_no: item[2].toString(),
                            student_name: item[3].toString(),
                            student_mobile: studentMobile !== "" ? studentMobile : fatherMobile,
                            // Student login password (Excel column 11). Left blank
                            // → backend defaults it to the student's mobile.
                            student_password: item[10] != null ? item[10].toString() : "",
                            father_name: fatherName,
                            father_phone: fatherMobile,
                            mother_name: item[7] ? item[7].toString() : "",
                            mother_phone: item[8] ? item[8].toString() : "",
                            parent_name: fatherName,
                            parent_mobile: fatherMobile !== "" ? fatherMobile : studentMobile,
                            parent_password: item[9] ? item[9].toString() : "",
                        });
                    }
                });
            }
            this.setState({ StudentsFilterData: studentData, fileError: "" });
        });
    };

    handleSingleInputChange = e => {
        const { name, value } = e.target;
        // Mobile fields: digits only, max 10.
        const mobileFields = ["s_mobile", "s_father_phone", "s_mother_phone"];
        const v = mobileFields.includes(name) ? value.replace(/\D/g, "").slice(0, 10) : value;
        this.setState({ [name]: v, singleError: "", submitError: "", successMessage: "" });
    };

    handleSingleImageChange = e => {
        const file = e.target.files[0];
        if (!file) return;
        const allowed = ["image/jpeg", "image/png", "image/jpg"];
        if (!allowed.includes(file.type)) {
            this.setState({ singleError: "Invalid image. Only JPG / PNG allowed." });
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            const img = new Image();
            img.onload = () => {
                // Compress to keep the Base64 well under 64KB (mirrors the edit modal: max 250px, JPEG 70%).
                const canvas = document.createElement("canvas");
                let { width, height } = img;
                const MAX = 250;
                if (width > height) { if (width > MAX) { height = Math.round(height * MAX / width); width = MAX; } }
                else { if (height > MAX) { width = Math.round(width * MAX / height); height = MAX; } }
                canvas.width = width; canvas.height = height;
                canvas.getContext("2d").drawImage(img, 0, 0, width, height);
                this.setState({ s_profile_base64: canvas.toDataURL("image/jpeg", 0.7), s_profile_name: file.name, singleError: "" });
            };
            img.src = reader.result;
        };
        reader.readAsDataURL(file);
        e.target.value = "";
    };

    handleSingleImageRemove = e => {
        if (e) e.preventDefault();
        this.setState({ s_profile_base64: "", s_profile_name: "" });
        if (this.singleFileRef) this.singleFileRef.value = "";
    };

    handleInputChange = e => {
        const { name, value } = e.target;
        const { branches, allClasses } = this.state;

        if (name === "branch") {
            if (value && value !== "0") {
                const selectedBranch = branches.find(b => String(b.id) === String(value));
                const sections = selectedBranch ? selectedBranch.sections || [] : [];
                const sectionClassIds = new Set(sections.map(s => String(s.class_id)));
                // Iterate allClasses (already sorted by order_no from getExamClasses)
                // so the dropdown follows order_no, not the section order.
                const classOptions = allClasses
                    .filter(c => sectionClassIds.has(String(c.id)))
                    .map(c => ({ value: c.id, label: c.class }));

                this.setState({
                    branch: value, branchError: "",
                    class: "", classError: "",
                    section: "", sectionError: "",
                    getClasses: classOptions, getSections: [],
                    StudentsFilterData: [], fileError: "",
                    submitError: "", successMessage: "",
                });
            } else {
                this.setState({
                    branch: "", branchError: "",
                    class: "", classError: "",
                    section: "", sectionError: "",
                    getClasses: [], getSections: [],
                    StudentsFilterData: [], fileError: "",
                    submitError: "", successMessage: "",
                });
            }
        }

        if (name === "class") {
            if (value && value !== "0") {
                const selectedBranch = branches.find(b => String(b.id) === String(this.state.branch));
                const sections = selectedBranch ? selectedBranch.sections || [] : [];

                // Streams available in this branch+class are derived from the
                // sections' stream_id, mapped to names via the stream master.
                const streamOptions = isStreamClass(value)
                    ? [...new Set(
                        sections
                            .filter(s => String(s.class_id) === String(value) && s.stream_id)
                            .map(s => s.stream_id)
                    )]
                        .map(sid => this.state.allStreams.find(st => String(st.id) === String(sid)))
                        .filter(Boolean)
                    : [];

                // For stream classes, sections are filtered by the chosen stream,
                // so hold off until a stream is selected.
                const sectionOptions = isStreamClass(value)
                    ? []
                    : sections
                        .filter(s => String(s.class_id) === String(value))
                        .map(s => ({ value: s.id, label: s.section_name }));

                this.setState({
                    class: value, classError: "",
                    stream: "", streamError: "",
                    section: "", sectionError: "",
                    getStreams: streamOptions,
                    getSections: sectionOptions,
                    StudentsFilterData: [], fileError: "",
                    submitError: "", successMessage: "",
                });
            } else {
                this.setState({
                    class: "", classError: "",
                    stream: "", streamError: "",
                    section: "", sectionError: "",
                    getStreams: [],
                    getSections: [],
                    StudentsFilterData: [], fileError: "",
                    submitError: "", successMessage: "",
                });
            }
        }

        if (name === "stream") {
            if (value && value !== "0") {
                const selectedBranch = branches.find(b => String(b.id) === String(this.state.branch));
                const sections = selectedBranch ? selectedBranch.sections || [] : [];
                const sectionOptions = sections
                    .filter(s => String(s.class_id) === String(this.state.class) && String(s.stream_id) === String(value))
                    .map(s => ({ value: s.id, label: s.section_name }));

                this.setState({
                    stream: value, streamError: "",
                    section: "", sectionError: "",
                    getSections: sectionOptions,
                    StudentsFilterData: [], fileError: "",
                    submitError: "", successMessage: "",
                });
            } else {
                this.setState({
                    stream: "", streamError: "",
                    section: "", sectionError: "",
                    getSections: [],
                    StudentsFilterData: [], fileError: "",
                    submitError: "", successMessage: "",
                });
            }
        }

        if (name === "section") {
            if (value && value !== "0") {
                this.setState({ section: value, sectionError: "", submitError: "", successMessage: "" });
            } else {
                this.setState({ section: "", sectionError: "", submitError: "", successMessage: "" });
            }
        }
    };

    handleFormSubmit = () => {
        // Synchronous re-entry guard — blocks double-clicks from firing two
        // parallel mutations (the disabled-button state updates too late, and the
        // backend's check-then-insert isn't atomic, so both would insert).
        if (this.isSubmittingFlag) return;

        const { branch, class: cls, stream, section, StudentsFilterData, activeTab } = this.state;

        if (!branch) return this.setState({ branchError: "Please select a branch" });
        if (!cls) return this.setState({ classError: "Please select a class" });
        if (isStreamClass(cls) && !stream) return this.setState({ streamError: "Please select a stream" });
        if (!section) return this.setState({ sectionError: "Please select a section" });

        let student_details;
        if (activeTab === "single") {
            if (!this.state.s_admission_no.trim() || !this.state.s_roll_no.trim() || !this.state.s_name.trim()) {
                return this.setState({ singleError: "Admission No, Roll No and Student Name are required." });
            }
            const fatherPhone = (this.state.s_father_phone || "").trim();
            const studentMobile = (this.state.s_mobile || "").trim();
            if (!studentMobile) return this.setState({ singleError: "Student Mobile is required." });
            if (studentMobile.length !== 10) return this.setState({ singleError: "Student Mobile must be 10 digits." });

            const fatherName = (this.state.s_father_name || "").trim();
            const parentPassword = (this.state.s_parent_password || "").trim();
            if (!fatherName) return this.setState({ singleError: "Parent (Father) Name is required." });
            if (!fatherPhone) return this.setState({ singleError: "Parent (Father) Mobile is required." });
            if (fatherPhone.length !== 10) return this.setState({ singleError: "Father Mobile must be 10 digits." });

            const motherPhoneVal = (this.state.s_mother_phone || "").trim();
            if (motherPhoneVal && motherPhoneVal.length !== 10) return this.setState({ singleError: "Mother Mobile must be 10 digits." });
            student_details = [{
                admission_no: this.state.s_admission_no.trim(),
                student_roll_no: this.state.s_roll_no.trim(),
                student_name: this.state.s_name.trim(),
                // Blank student mobile falls back to father's — mirrors the bulk mapping.
                student_mobile: studentMobile !== "" ? studentMobile : fatherPhone,
                student_password: (this.state.s_password || "").trim(),
                father_name: (this.state.s_father_name || "").trim(),
                father_phone: fatherPhone,
                mother_name: (this.state.s_mother_name || "").trim(),
                mother_phone: (this.state.s_mother_phone || "").trim(),
                parent_name: (this.state.s_father_name || "").trim(),
                parent_mobile: fatherPhone !== "" ? fatherPhone : studentMobile,
                // Send exactly what's typed — blank stays blank (never the mobile number).
                parent_password: parentPassword,
                // Base64 image sent under profile_image; backend uploads it and
                // stores the resulting URL back into profile_image.
                profile_image: this.state.s_profile_base64 || "",
                profile_image_base: "",
            }];
        } else {
            if (!StudentsFilterData.length) return this.setState({ fileError: "Please upload a student file" });
            student_details = StudentsFilterData;
        }

        this.isSubmittingFlag = true;
        this.setState({ isSubmitting: true, loadingSpinner: 1, submitError: "", successMessage: "" });

        const params = {
            branch_id: parseInt(branch),
            class_id: parseInt(cls),
            stream_id: isStreamClass(cls) && stream ? parseInt(stream) : null,
            section_id: parseInt(section),
            institute_id: parseInt(Cookies.get("institutionid")),
            student_details,
        };

        this.AddEducationalStudents(params).catch(error => {
            this.isSubmittingFlag = false;
            this.setState({
                submitError: error.graphQLErrors?.map(x => x.message)[0] || "Submission failed. Please try again.",
                loadingSpinner: 0,
                isSubmitting: false,
            });
        });
    };

    AddEducationalStudents = async params => {
        await this.props.AddEducationalStudents({
            variables: { params },
            update: (store, { data }) => {
                if (data.AddEducationalStudents) {
                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5,
                        isSubmitting: false,
                        successMessage: "Students added successfully!",
                    });
                    setTimeout(() => {
                        this.props.onHide();
                        if (this.props.onSuccess) {
                            this.props.onSuccess();
                        }
                    }, 1500);
                }
            },
        });
    };

    articlecolumns = [
        { dataField: "admission_no", text: "Admission No", sort: true },
        { dataField: "student_name", text: "Student Name", sort: true },
        { dataField: "student_roll_no", text: "Roll No", sort: true },
        { dataField: "student_mobile", text: "Mobile", sort: true },
        { dataField: "student_password", text: "Password", sort: false, formatter: (cell) => cell || "(mobile)" },
        { dataField: "father_name", text: "Father Name", sort: true },
        { dataField: "father_phone", text: "Father Mobile", sort: true },
        { dataField: "mother_name", text: "Mother Name", sort: true },
        { dataField: "mother_phone", text: "Mother Mobile", sort: true },
    ];

    render() {
        const {
            branches, getClasses, getStreams, getSections,
            StudentsFilterData, successMessage, submitError,
            loadingSpinner, isSubmitting,
        } = this.state;

        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton className="edu-modal-header">
                    <Modal.Title>
                        <span style={{ width: 9, height: 9, background: 'rgba(255,255,255,0.9)', borderRadius: '50%', display: 'inline-block', marginRight: 10 }}></span>
                        Add Students
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="edu-modal-body">

                    {/* ── Tabs: Single Student · Bulk Students ── */}
                    <div style={{ display: "flex", gap: 8, marginBottom: 18, borderBottom: "1.5px solid #e2e8f0" }}>
                        {[
                            { key: "single", label: "Single Student", icon: "fas fa-user" },
                            { key: "bulk", label: "Bulk Students", icon: "fas fa-users" },
                        ].map(({ key, label, icon }) => {
                            const isActive = this.state.activeTab === key;
                            return (
                                <button
                                    key={key}
                                    type="button"
                                    onClick={() => this.setState({ activeTab: key, submitError: "", successMessage: "", singleError: "", fileError: "" })}
                                    style={{
                                        display: "flex", alignItems: "center", gap: 7,
                                        padding: "10px 18px", fontWeight: 700, fontSize: 13.5,
                                        cursor: "pointer", background: "transparent", border: "none",
                                        color: isActive ? "#6366f1" : "#6b7280",
                                        borderBottom: isActive ? "2.5px solid #6366f1" : "2.5px solid transparent",
                                        marginBottom: "-1.5px", transition: "all 0.15s",
                                    }}
                                >
                                    <i className={icon} /> {label}
                                </button>
                            );
                        })}
                    </div>

                    {/* ── Select Configuration ── */}
                    <div className="edu-form-section">
                        <div className="edu-filter-title mb-3" style={{ color: "#2563eb" }}>
                            <i className="fas fa-cog" style={{ color: "#2563eb" }}></i> SELECT CONFIGURATION
                        </div>
                        <Form>
                            <Form.Row>
                                <Form.Group as={Col} lg={4} md={6} sm={12} controlId="SelectBranch">
                                    <Form.Label className="edu-form-label">Branch <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        as="select"
                                        className="edu-form-control"
                                        name="branch"
                                        onChange={this.handleInputChange}
                                        value={this.state.branch}
                                    >
                                        <option value="0">-- Select Branch --</option>
                                        {branches.map(b => (
                                            <option key={b.id} value={b.id}>{b.branch_name}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="text-danger">{this.state.branchError}</Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} lg={4} md={6} sm={12} controlId="SelectClass">
                                    <Form.Label className="edu-form-label">Class <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        as="select"
                                        className="edu-form-control"
                                        name="class"
                                        onChange={this.handleInputChange}
                                        value={this.state.class}
                                        disabled={!this.state.branch}
                                    >
                                        <option value="0">-- Select Class --</option>
                                        {getClasses.map(c => (
                                            <option key={c.value} value={c.value}>{c.label}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="text-danger">{this.state.classError}</Form.Text>
                                </Form.Group>

                                {isStreamClass(this.state.class) && (
                                    <Form.Group as={Col} lg={4} md={6} sm={12} controlId="SelectStream">
                                        <Form.Label className="edu-form-label">Stream <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            as="select"
                                            className="edu-form-control"
                                            name="stream"
                                            onChange={this.handleInputChange}
                                            value={this.state.stream}
                                            disabled={!this.state.class}
                                        >
                                            <option value="0">-- Select Stream --</option>
                                            {getStreams.map(st => (
                                                <option key={st.id} value={st.id}>{st.stream}</option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="text-danger">{this.state.streamError}</Form.Text>
                                    </Form.Group>
                                )}

                                <Form.Group as={Col} lg={4} md={6} sm={12} controlId="SelectSection">
                                    <Form.Label className="edu-form-label">Section <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        as="select"
                                        className="edu-form-control"
                                        name="section"
                                        onChange={this.handleInputChange}
                                        value={this.state.section}
                                        disabled={!this.state.class || (isStreamClass(this.state.class) && !this.state.stream)}
                                    >
                                        <option value="0">-- Select Section --</option>
                                        {getSections.map(s => (
                                            <option key={s.value} value={s.value}>{s.label}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="text-danger">{this.state.sectionError}</Form.Text>
                                </Form.Group>

                            </Form.Row>

                        </Form>
                    </div>

                    {/* ── SINGLE STUDENT FORM ── */}
                    {this.state.activeTab === "single" && (
                        <>
                        <div className="edu-form-section mt-3">
                            <div className="edu-filter-title mb-3" style={{ color: "#2563eb" }}>
                                <i className="fas fa-user" style={{ color: "#2563eb" }}></i> STUDENT DETAILS
                            </div>
                            <Form>
                                <Form.Row>
                                    <Col lg={12} className="mb-3 d-flex flex-column align-items-center">
                                        <style>{`.edu-profile-upload-wrapper:hover .edu-profile-upload-overlay { opacity: 1 !important; }`}</style>
                                        <div
                                            className="edu-profile-upload-wrapper"
                                            onClick={() => this.singleFileRef && this.singleFileRef.click()}
                                            style={{ position: "relative", width: 96, height: 96, borderRadius: "50%", border: "2px dashed #93c5fd", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", background: "#eff6ff", cursor: "pointer" }}
                                        >
                                            {this.state.s_profile_base64 ? (
                                                <img src={this.state.s_profile_base64} alt="Profile" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                            ) : (
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", color: "#2563eb" }}>
                                                    <i className="fas fa-camera" style={{ fontSize: 20 }} />
                                                    <span style={{ fontSize: 10, marginTop: 4, fontWeight: 600 }}>Upload</span>
                                                </div>
                                            )}
                                            <div className="edu-profile-upload-overlay" style={{ position: "absolute", bottom: 0, left: 0, right: 0, background: "rgba(0,0,0,0.5)", color: "#fff", fontSize: 10, textAlign: "center", padding: "3px 0", opacity: 0, transition: "opacity 0.2s" }}>Change</div>
                                        </div>
                                        {this.state.s_profile_base64 ? (
                                            <button type="button" onClick={this.handleSingleImageRemove} style={{ marginTop: 8, background: "transparent", border: "none", color: "#dc2626", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
                                                <i className="fal fa-times-circle mr-1" />Remove photo
                                            </button>
                                        ) : null}
                                        <input type="file" ref={ref => this.singleFileRef = ref} style={{ display: "none" }} accept="image/*" onChange={this.handleSingleImageChange} />
                                    </Col>
                                    <Form.Group as={Col} lg={4} md={6} sm={12}>
                                        <Form.Label className="edu-form-label">Admission No <span className="text-danger">*</span></Form.Label>
                                        <Form.Control className="edu-form-control" type="text" name="s_admission_no" value={this.state.s_admission_no} onChange={this.handleSingleInputChange} autoComplete="off" />
                                    </Form.Group>
                                    <Form.Group as={Col} lg={4} md={6} sm={12}>
                                        <Form.Label className="edu-form-label">Roll No <span className="text-danger">*</span></Form.Label>
                                        <Form.Control className="edu-form-control" type="text" name="s_roll_no" value={this.state.s_roll_no} onChange={this.handleSingleInputChange} autoComplete="off" />
                                    </Form.Group>
                                    <Form.Group as={Col} lg={4} md={6} sm={12}>
                                        <Form.Label className="edu-form-label">Student Name <span className="text-danger">*</span></Form.Label>
                                        <Form.Control className="edu-form-control" type="text" name="s_name" value={this.state.s_name} onChange={this.handleSingleInputChange} autoComplete="off" />
                                    </Form.Group>
                                    <Form.Group as={Col} lg={4} md={6} sm={12}>
                                        <Form.Label className="edu-form-label">Student Mobile <span className="text-danger">*</span></Form.Label>
                                        <Form.Control className="edu-form-control" type="text" inputMode="numeric" maxLength={10} name="s_mobile" value={this.state.s_mobile} onChange={this.handleSingleInputChange} autoComplete="off" />
                                    </Form.Group>
                                    <Form.Group as={Col} lg={4} md={6} sm={12}>
                                        <Form.Label className="edu-form-label">Student Password</Form.Label>
                                        <Form.Control className="edu-form-control" type="text" name="s_password" value={this.state.s_password} onChange={this.handleSingleInputChange} placeholder="Defaults to mobile" autoComplete="off" />
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        </div>

                        <div className="edu-form-section mt-3">
                            <div className="edu-filter-title mb-3" style={{ color: "#2563eb" }}>
                                <i className="fas fa-users" style={{ color: "#2563eb" }}></i> PARENT DETAILS
                            </div>
                            <Form>
                                <Form.Row>
                                    <Form.Group as={Col} lg={4} md={6} sm={12}>
                                        <Form.Label className="edu-form-label">Father Name <span className="text-danger">*</span></Form.Label>
                                        <Form.Control className="edu-form-control" type="text" name="s_father_name" value={this.state.s_father_name} onChange={this.handleSingleInputChange} autoComplete="off" />
                                    </Form.Group>
                                    <Form.Group as={Col} lg={4} md={6} sm={12}>
                                        <Form.Label className="edu-form-label">Father Mobile <span className="text-danger">*</span></Form.Label>
                                        <Form.Control className="edu-form-control" type="text" inputMode="numeric" maxLength={10} name="s_father_phone" value={this.state.s_father_phone} onChange={this.handleSingleInputChange} autoComplete="off" />
                                    </Form.Group>
                                    <Form.Group as={Col} lg={4} md={6} sm={12}>
                                        <Form.Label className="edu-form-label">Mother Name</Form.Label>
                                        <Form.Control className="edu-form-control" type="text" name="s_mother_name" value={this.state.s_mother_name} onChange={this.handleSingleInputChange} autoComplete="off" />
                                    </Form.Group>
                                    <Form.Group as={Col} lg={4} md={6} sm={12}>
                                        <Form.Label className="edu-form-label">Mother Mobile</Form.Label>
                                        <Form.Control className="edu-form-control" type="text" inputMode="numeric" maxLength={10} name="s_mother_phone" value={this.state.s_mother_phone} onChange={this.handleSingleInputChange} autoComplete="off" />
                                    </Form.Group>
                                    <Form.Group as={Col} lg={4} md={6} sm={12}>
                                        <Form.Label className="edu-form-label">Parent Password</Form.Label>
                                        <Form.Control className="edu-form-control" type="text" name="s_parent_password" value={this.state.s_parent_password} onChange={this.handleSingleInputChange} placeholder="Defaults to parent mobile" autoComplete="off" />
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        </div>
                        {this.state.singleError && <div className="text-danger" style={{ fontSize: 13, marginTop: -6, marginBottom: 8 }}>{this.state.singleError}</div>}
                        </>
                    )}

                    {/* ── BULK FILE UPLOAD ── */}
                    {this.state.activeTab === "bulk" &&
                        this.state.branch !== "" && this.state.class !== "" && this.state.section !== "" &&
                        (!isStreamClass(this.state.class) || this.state.stream !== "") && (
                            <div className="edu-form-section mt-3">
                                <div className="edu-filter-title mb-3">
                                    <i className="fas fa-file-excel"></i> UPLOAD STUDENTS FILE
                                </div>
                                <Form>
                                    <Form.Row>
                                        <Form.Group controlId="formFile" as={Col} lg={6} md={12} sm={12}>
                                            <Form.Label className="edu-form-label">
                                                <a href={SampleExcel} download className="edu-download-link">
                                                    <i className="fas fa-download"></i> Download Sample File
                                                </a>
                                            </Form.Label>
                                            <div className="edu-file-upload">
                                                <Form.Control name="file" type="file" onChange={this.handleFileChange} />
                                            </div>
                                            <Form.Text className="text-danger">{this.state.fileError}</Form.Text>
                                        </Form.Group>
                                    </Form.Row>
                                </Form>
                            </div>
                        )}



                    {/* ── Upload Preview ── */}
                    {this.state.activeTab === "bulk" && StudentsFilterData.length > 0 && (
                        <div className="mt-3">
                            <div className="edu-table-card">
                                <div className="edu-table-header">
                                    <span className="edu-table-title">
                                        <i className="fas fa-table"></i> Upload Preview
                                    </span>
                                    <span className="edu-count-badge">{StudentsFilterData.length} Records</span>
                                </div>
                                <TableSearchwithStudentResult
                                    parentData={StudentsFilterData}
                                    particlecolumns={this.articlecolumns}
                                    defaultSorted={{ dataField: "student_name", order: "asc" }}
                                />
                            </div>
                        </div>
                    )}

                </Modal.Body>

                <Modal.Footer className="edu-modal-footer">
                    <div className="d-flex align-items-center justify-content-between w-100">
                        <div>
                            {successMessage && (
                                <span style={{ color: "#16A34A", fontWeight: 600, fontSize: 13 }}>
                                    <i className="fas fa-check-circle mr-1"></i>{successMessage}
                                </span>
                            )}
                            {submitError && (
                                <span style={{ color: "#EF4444", fontSize: 13 }}>
                                    <i className="fas fa-exclamation-circle mr-1"></i>{submitError}
                                </span>
                            )}
                        </div>
                        <button
                            className="addeEdit_btn"
                            onClick={this.handleFormSubmit}
                            disabled={isSubmitting}
                        >
                            {loadingSpinner === 1
                                ? <span className="spinner-border spinner-border-sm mr-1"></span>
                                : <i className="fas fa-user-plus mr-1"></i>
                            }
                            Submit
                        </button>
                    </div>
                </Modal.Footer>

            </Modal>
        );
    }
}

export default compose(
    withApollo,
    graphql(ADD_STUDENT, { name: "AddEducationalStudents" })
)(StudentModal);
